import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';

const StyledSlider = withStyles({
  root: {
    color: '#780F9E',
    height: 8,
    '&$disabled': {
      color: '#B0B0B0', // Gray color when disabled
    }
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
    '&$disabled': {
      height: 24,
      width: 24,
      backgroundColor: '#FFF', // Gray thumb background when disabled
      border: '2px solid #B0B0B0', 
      marginTop: -8,
      marginLeft: -12,// Gray thumb border when disabled
    },
  },
  active: {},
  disabled: {}, // Add the disabled class
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
    '&$disabled': {
      backgroundColor: '#B0B0B0', // Gray track when disabled
    },
  },
  rail: {
    height: 8,
    borderRadius: 4,
    '&$disabled': {
      backgroundColor: '#f0f0f0', // Lighter gray rail when disabled
    },
  },
  mark: {
    display: 'none',
  },
})(Slider);




export default function ContinuousSlider({zoom, setZoom, disabled}) {


  const handleChange = (event, newValue) => {
    setZoom(Math.round(newValue * 100) / 100);
  };
 

  const marks = [
    {
      value: 10,
      label: '10%',
    },

    {
      value: 100,
      label: '100%',
    },
    {
      value: 200,
      label: '200%',
    },
  ];
  function valuetext(value) {
    return `${value}`;
  }
  return (
    <Box sx={{
        gap: '1rem',
        width: '440px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 8,
        left: '50%',
        background: '#FFF',
        borderRadius: '30px',
        transform: 'translateX(-50%)',
        boxShadow: 'rgba(0, 0, 0, 0.12) 2px 2px 6px'
      }}>
     <Box sx={{position:"relative", width:40, top:"0px", fontWeight:500, fontSize:"1em"}}> Zoom </Box>
      <div style={{ marginTop: '4px' , width:"300px"}}>
        <StyledSlider 
          aria-label="Zoom" 
          value={zoom} 
          onChange={handleChange} 
          min={10}
          getAriaValueText={valuetext}
          // marks={marks}
          max={200} 
          step={1} 
          disabled={disabled}
        />
    
      </div>
      <Box sx={{position:"relative",width:40, top:"0px", fontWeight:500, fontSize:"1em"}}> {`${zoom}%`}</Box>
    </Box>
  );
}
